import React, { useState, useEffect } from 'react';
import { ShieldCheck, ShieldAlert, Key, Send, User, Lock, RefreshCw } from 'lucide-react';

const AdminSeguranca = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const [resetEmail, setResetEmail] = useState('');
    const [sending, setSending] = useState(false);

    const fetchStats = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch('/api/seguranca/stats', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                setStats(await response.json());
            }
        } catch (error) {
            console.error("Erro stats:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const handleSendReset = async (e) => {
        e.preventDefault();
        if (!resetEmail) return;
        if (!window.confirm(`Enviar link de redefinição para ${resetEmail}?`)) return;
        
        setSending(true);
        // Simulação de envio - Troque pela sua chamada real à API
        setTimeout(() => {
            alert("Link enviado com sucesso!");
            setSending(false);
            setResetEmail('');
        }, 1000);
    };

    // Cores e Temas do Módulo de Segurança
    const themeRed = '#e11d48'; // Vermelho Principal
    const bgRedLight = '#fff1f2';
    const themeOrange = '#ea580c'; // Laranja para Riscos
    const bgOrangeLight = '#fff7ed';

    return (
        <div>
            
            {/* CABEÇALHO DO MÓDULO */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ padding: '12px', backgroundColor: bgRedLight, borderRadius: '12px', color: themeRed }}>
                        <ShieldCheck size={28} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: '0 0 4px 0' }}>Central de Segurança</h2>
                        <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>Gestão de acessos privilegiados e ferramentas de recuperação.</p>
                    </div>
                </div>

                <button 
                    onClick={fetchStats} 
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                >
                    <RefreshCw size={16} className={loading ? "animate-spin" : ""} color={themeRed} /> 
                    Atualizar Dados
                </button>
            </div>

            {/* VISÃO GERAL (GRID DE ESTATÍSTICAS) */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '24px', marginBottom: '32px' }}>
                
                {/* Card: Admins Globais */}
                <div style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0', borderLeft: `4px solid ${themeRed}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
                    <div>
                        <p style={{ color: themeRed, fontSize: '12px', textTransform: 'uppercase', fontWeight: '800', margin: '0 0 8px 0', letterSpacing: '0.05em' }}>Administradores Globais</p>
                        <h3 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '0 0 4px 0' }}>{stats?.totalAdmins || 0}</h3>
                        <p style={{ fontSize: '13px', color: '#64748b', margin: 0, fontWeight: '500' }}>Utilizadores com acesso total</p>
                    </div>
                    <div style={{ padding: '16px', borderRadius: '50%', backgroundColor: bgRedLight, color: themeRed }}>
                        <ShieldAlert size={32} />
                    </div>
                </div>

                {/* Card: Risco */}
                <div style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '16px', border: '1px solid #e2e8f0', borderLeft: `4px solid ${themeOrange}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
                    <div>
                        <p style={{ color: themeOrange, fontSize: '12px', textTransform: 'uppercase', fontWeight: '800', margin: '0 0 8px 0', letterSpacing: '0.05em' }}>Risco: Primeiro Acesso</p>
                        <h3 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '0 0 4px 0' }}>{stats?.vulnerableAccounts || 0}</h3>
                        <p style={{ fontSize: '13px', color: '#64748b', margin: 0, fontWeight: '500' }}>Contas com password padrão</p>
                    </div>
                    <div style={{ padding: '16px', borderRadius: '50%', backgroundColor: bgOrangeLight, color: themeOrange }}>
                        <Key size={32} />
                    </div>
                </div>

            </div>

            {/* SEÇÃO DE FERRAMENTAS E LISTAS */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
                
                {/* LISTA DE ADMINS */}
                <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: '20px 24px', backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <User size={18} color="#475569" />
                            <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Quem são os Admins?</h3>
                        </div>
                        <span style={{ fontSize: '11px', fontWeight: '700', backgroundColor: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px' }}>Lista Ativa</span>
                    </div>
                    
                    <div style={{ padding: '0', flex: 1, overflowY: 'auto', maxHeight: '400px' }}>
                        {loading ? (
                            <div style={{ padding: '30px', textAlign: 'center', color: '#64748b' }}>A carregar dados...</div>
                        ) : !stats?.adminList || stats.adminList.length === 0 ? (
                            <div style={{ padding: '30px', textAlign: 'center', color: '#64748b' }}>Nenhum administrador encontrado.</div>
                        ) : (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {stats.adminList.map((admin, index) => (
                                    <li key={admin.ID} style={{ padding: '16px 24px', borderBottom: index !== stats.adminList.length - 1 ? '1px solid #f1f5f9' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'background-color 0.2s' }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'} onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                            {/* Avatar Gerado */}
                                            <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: bgRedLight, color: themeRed, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '16px', border: `1px solid #fecdd3` }}>
                                                {admin.NOME_COMPLETO ? admin.NOME_COMPLETO.charAt(0).toUpperCase() : 'U'}
                                            </div>
                                            <div>
                                                <p style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: '700', color: '#0f172a' }}>{admin.NOME_COMPLETO}</p>
                                                <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>{admin.EMAIL}</p>
                                            </div>
                                        </div>
                                        <span style={{ fontSize: '12px', fontFamily: 'monospace', color: '#94a3b8', fontWeight: '600', backgroundColor: '#f1f5f9', padding: '4px 8px', borderRadius: '4px' }}>
                                            #{admin.ID}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* FERRAMENTA DE RESET DE SENHA */}
                <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: '20px 24px', backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Lock size={18} color="#0284c7" />
                        <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Reset de Password</h3>
                    </div>

                    <div style={{ padding: '24px', flex: 1 }}>
                        <p style={{ color: '#475569', fontSize: '14px', lineHeight: '1.6', marginBottom: '24px' }}>
                            Utilize esta ferramenta para enviar um link de redefinição seguro para utilizadores que perderam o acesso ou que necessitam de alterar a palavra-passe por motivos de segurança.
                        </p>

                        <form onSubmit={handleSendReset}>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#64748b', marginBottom: '8px', letterSpacing: '0.05em' }}>EMAIL DO UTILIZADOR</label>
                                <input 
                                    type="email" 
                                    required
                                    placeholder="nome@grupocorreia.com"
                                    value={resetEmail}
                                    onChange={(e) => setResetEmail(e.target.value)}
                                    style={{ width: '100%', padding: '12px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontSize: '14px', color: '#0f172a', transition: 'border-color 0.2s' }}
                                    onFocus={(e) => e.currentTarget.style.borderColor = '#0284c7'}
                                    onBlur={(e) => e.currentTarget.style.borderColor = '#cbd5e1'}
                                />
                            </div>
                            
                            <button 
                                type="submit" 
                                disabled={sending || !resetEmail} 
                                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '14px', backgroundColor: sending || !resetEmail ? '#cbd5e1' : '#0f172a', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '600', fontSize: '14px', cursor: sending || !resetEmail ? 'not-allowed' : 'pointer', transition: 'background-color 0.2s' }}
                            >
                                {sending ? 'A enviar correio...' : 'Enviar Link de Recuperação'} 
                                {!sending && <Send size={16} />}
                            </button>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdminSeguranca;